import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-recurring',
    templateUrl: './recurring.component.html',
    styleUrls: ['./recurring.component.scss'],
    standalone: false
})
export class RecurringComponent {
  isMobile: boolean;

  constructor(private deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile();
  }
}
